import React from "react"

const FormFieldWarning = ({message = ""}) =>{
    if(message === "") return null;
    return(
        <p className={"text text-warning"}><i className="bi bi-exclamation-circle"></i> {message}</p>
    )
}

export default FormFieldWarning